import AssessmentForm from "@container/asess-section/assessment-form";
import AuthLayout from "@container/layout/auth";

export default function EmployerAssessFormEditPage() {
    return (
        <AuthLayout>
            <AssessmentForm isEditMode />
        </AuthLayout>
    );
}
